import React, {Component} from 'react';
import {Link as RouterLink} from 'react-router-dom';
import './Projects.css';
import Card from 'react-bootstrap/Card'
import expense01 from './assets/Expense-01.png';
import sortVisualizer from './assets/Sort-Visualizer.png';
import transactionRiskEngine from './assets/Transaction-risk-engine dashboard.png';
import tennisStore01 from './assets/Tennis-Store01.png';
import university01 from './assets/University01.png';
import contact01 from './assets/Contacts01.png';

class Projects extends Component {
    state = {  }
    render() {
        return (
            <div>
                <div className="divProjectsStyle">
                <div className="divAboutMeHeader" >
                   <h1 >  Projects </h1>
                   <hr className="solid"></hr>
                </div>
                <div className="divProjects-Cards featuredProjectRow">
                    <div className="divProjects-Cards-inside">
                <Card className="featuredProjectCard" style={{ width: '90%', height: '100%'  }}>
                    <video
                        className="card-img-top projectDemoVideo"
                        controls
                        preload="metadata"
                        poster={transactionRiskEngine}
                    >
                        <source src="/videos/transaction-risk-engine-demo.mp4" type="video/mp4" />
                    </video>
                    <Card.Body>
                        <p className="projectEyebrow">Featured project</p>
                        <Card.Title>Transaction-Risk-Engine</Card.Title>
                        <Card.Text>
                        I built Transaction Risk Engine to explore how real-time financial transaction monitoring systems can be designed using event-driven backend architecture. The project focuses on reliable ingestion, asynchronous risk evaluation, alert generation, and a simple analyst dashboard. It gave me a practical way to apply Spring Boot, Kafka, PostgreSQL, the transactional outbox pattern, and service-oriented design in a finance-oriented use case.
                        </Card.Text>
                        <div className="project-card-actions">
                            <RouterLink to="/Transaction-Risk-Engine">Project Details</RouterLink>
                            <a href="https://github.com/ankitlalwani/transaction-risk-engine" target="_blank" rel="noopener noreferrer">Codebase</a>
                            <span className="project-action-disabled">Demo</span>
                        </div>
                    </Card.Body>
                    </Card>
                    </div>
                    </div>
                <div className="divProjects-Cards">
                    <div className="divProjects-Cards-inside">
                <Card style={{ width: '90%', height: '100%'  }}>
                    <Card.Img variant="top" src={sortVisualizer} />
                    <Card.Body>
                        <Card.Title>Sorting Visualizer</Card.Title>
                        <Card.Text>
                        Visualize the popular comparison based sorting algorithms for easy understanding.
                        This visualizer is build using ReactJS.
                        </Card.Text>
                        <div className="project-card-actions">
                            <a href="https://github.com/ankitlalwani/sortVisualizer/" target="_blank" rel="noopener noreferrer">Code Details</a>
                            <a href="https://ankitlalwani.github.io/sortVisualizer/" target="_blank" rel="noopener noreferrer">Demo</a>
                        </div>
                    </Card.Body>
                    </Card>
                    </div>
                    <div className="divProjects-Cards-inside">
                <Card style={{ width: '90%', height: '100%'  }}>
                    <Card.Img variant="top" src={expense01} />
                    <Card.Body>
                        <Card.Title>Expense Tracker</Card.Title>
                        <Card.Text>
                        Keep track of your expenses and get monthly reports.
                        Application Built using React and Spring-Boot and H2 database.
                        </Card.Text>
                        <div className="project-card-actions">
                            <a href="https://github.com/ankitlalwani/Expense-Calculator-in-React" target="_blank" rel="noopener noreferrer">Code Details</a>
                        </div>
                    </Card.Body>
                    </Card>
                    </div>
                    </div>
                    <div className="divProjects-Cards">
                    <div className="divProjects-Cards-inside">
                    <Card style={{ width: '90%', height: '100%' }}>
                    <Card.Img variant="top" src={tennisStore01} />
                    <Card.Body>
                        <Card.Title>Tennis Store App</Card.Title>
                        <Card.Text>
                        The ultimate shopping experience to buy tennis equipments and accessories.
                        The application is build using Spring-Boot and MySQL.
                        </Card.Text>
                        <div className="project-card-actions">
                            <a href="https://github.com/ankitlalwani/hplusapp" target="_blank" rel="noopener noreferrer">Code Details</a>
                        </div>
                    </Card.Body>
                    </Card>
                    </div>
                    <div className="divProjects-Cards-inside">
                    <Card style={{ width: '90%', height: '100%' }}>
                    <Card.Img variant="top" src={university01} />
                    <Card.Body>
                        <Card.Title>Extracurricular Database</Card.Title>
                        <Card.Text>
                        University Portal to track their students Extracurricular activities.
                        Built in Spring and MySQL.
                        </Card.Text>
                        <div className="project-card-actions">
                            <a href="/">Code Details</a>
                        </div>
                    </Card.Body>
                    </Card>
                    </div>
                    </div>
                    <div className="divProjects-Cards">
                    <div className="divProjects-Cards-inside">
                    <Card style={{ width: '90%', height: '100%' }}>
                    <Card.Img variant="top" src={contact01} />
                    <Card.Body>
                        <Card.Title>Contacts Card Management</Card.Title>
                        <Card.Text>
                        Application to store contact related information for clients.<br/>
                        Built in Spring and React.
                        </Card.Text>
                        <div className="project-card-actions">
                            <a href="https://github.com/ankitlalwani/crm" target="_blank" rel="noopener noreferrer">Code Details</a>
                        </div>
                    </Card.Body>
                    </Card>
                    </div>
                    </div>
            </div >
            </div>
         );
    }
}

export default Projects;
